"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationDataForDriver = void 0;
const class_transformer_1 = require("class-transformer");
const AssignationPayout_1 = require("../models/AssignationPayout");
const Compensation_1 = require("../models/Compensation");
const DriverDebt_1 = require("../models/DriverDebt");
const Passenger_1 = require("../models/Passenger");
const Penalty_1 = require("../models/Penalty");
const Subsidy_1 = require("../models/Subsidy");
class AssignationDataForDriver {
    assignationId;
    originLocationName;
    destinationLocationName;
    departureAt;
    vehicleTitle;
    customerName;
    passengers;
    amountForDriver;
    driversBalance;
    paidCash;
    paidOnline;
    penalties;
    compensations;
    subsidies;
    sumOfPenalties;
    sumOfCompensations;
    sumOfSubsidies;
    assignationPayouts;
    driverDebts;
    sumOfPayouts;
    sumOfDebts;
    status;
    driverName;
    totalPrice;
    fee;
}
exports.AssignationDataForDriver = AssignationDataForDriver;
__decorate([
    (0, class_transformer_1.Type)(() => Date),
    (0, class_transformer_1.Transform)(({ value }) => new Date(value)),
    __metadata("design:type", Date)
], AssignationDataForDriver.prototype, "departureAt", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Passenger_1.Passenger),
    __metadata("design:type", Array)
], AssignationDataForDriver.prototype, "passengers", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Penalty_1.Penalty),
    __metadata("design:type", Array)
], AssignationDataForDriver.prototype, "penalties", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Compensation_1.Compensation),
    __metadata("design:type", Array)
], AssignationDataForDriver.prototype, "compensations", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => Subsidy_1.Subsidy),
    __metadata("design:type", Array)
], AssignationDataForDriver.prototype, "subsidies", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => AssignationPayout_1.AssignationPayout),
    __metadata("design:type", Array)
], AssignationDataForDriver.prototype, "assignationPayouts", void 0);
__decorate([
    (0, class_transformer_1.Type)(() => DriverDebt_1.DriverDebt),
    __metadata("design:type", Array)
], AssignationDataForDriver.prototype, "driverDebts", void 0);
//# sourceMappingURL=AssignationDataForDriver.js.map